import styled from 'styled-components'

export const AlarmListContainer = styled.div`
    background: var(--gray-0);
    height: calc(100% - 156px);
    width: 511px;
    position: fixed;
    right: 21px;
    border: 1px solid var(--gray-400);
    padding: 24px 24px 24px 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    z-index: 2;

    .alarm-list-header {
        .list-header-first-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;

            .first-row-title {
                display: flex;
                gap: 5px;
                align-items: center;
            }

            i {
                font-size: 12px;
                font-weight: 400;
            }

            .fa-times {
                cursor: pointer;
            }
        }

        .list-header-detected-alarms {
        }
    }

    .alarm-list-filter {
        display: flex;
        gap: 8px;
        flex-direction: column;

        i {
            color: var(--blue-500);
        }

        .select-dropdown {
            width: 302px;
            display: flex;
            flex-direction: column;
            padding: 16px;
            gap: 16px;
            position: absolute;
            background: var(--gray-0);
            top: 128px;
            left: 16px;
            right: 0px;
            box-shadow: 0px 4px 6px rgba(161, 174, 191, 0.25);
            border-radius: 3px;
            border: 1px solid var(--gray-400);
            background: var(--gray-0);
            z-index: 90;
        }
        .sort-dropdown {
            width: 192px;
            position: absolute;
            background: var(--gray-0);
            top: 128px;
            left: 189px;
            box-shadow: 0px 4px 6px rgba(161, 174, 191, 0.25);
            border-radius: 3px;
            border: 1px solid var(--gray-400);
            display: flex;
            flex-direction: column;
            gap: 9px;
            background: var(--gray-0);
            z-index: 90;
            .items-filter {
                display: flex;
                justify-content: space-around;
                align-items: center;
                font-size: 13px;
                font-weight: 400;
                padding: 9.5px 0;
                cursor: pointer;
            }

            .divider {
                border: 0.25px solid ${({ theme }) => theme['gray-600']};
            }
        }

        .list-filter {
            display: flex;
            gap: 10px;

            &.first-row {
                .first-row-filter-buttons {
                    display: flex;
                    align-items: center;

                    .filter-button {
                        width: 302px;
                        border-radius: 3px 0px 0px 3px;
                        padding: 12px;
                        border: 1px solid var(--gray-400);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        cursor: pointer;

                        i {
                            font-size: 13px;
                        }

                        .icon-label-bundle {
                            display: flex;
                            gap: 6px;
                            align-items: center;
                        }
                    }

                    .order-button {
                        font-size: 16px;
                        width: 44px;
                        padding: 12px 16px;
                        border-radius: 0px 3px 3px 0px;
                        border: 1px solid var(--gray-400);
                        border-left: none;
                        cursor: pointer;
                    }
                }
            }

            &.second-row {
                align-items: center;
                .tags-row {
                    display: flex;
                    flex-direction: row;
                    width: calc(100% - 190px);
                    gap: 8px;
                    flex-wrap: wrap;

                    .selected-tag {
                        display: flex;
                        flex-wrap: wrap;
                        border: 1px solid ${({ theme }) => theme['gray-600']};
                        gap: 8px;
                        padding: 2px 8px;
                        border-radius: 3px;
                        /* max-width: 40%; */
                        height: 22px;
                        font-size: 12px;
                        font-weight: 600;
                        color: ${({ theme }) => theme['gray-600']};
                        align-items: center;
                    }

                    .fa-times {
                        color: ${({ theme }) => theme['gray-600']};
                        cursor: pointer;
                    }
                }
                .selected-filter {
                    width: 110px;
                }
                .clear {
                    width: 80px;
                    display: flex;
                    justify-content: end;

                    .clear-label {
                        color: ${({ theme }) => theme['blue-500']};
                        font-size: 11px;
                        font-weight: 400;
                        cursor: pointer;
                    }
                }
            }
        }
    }
`

export const CardList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: scroll;
    height: calc(100% - 32px);
`
